import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-report',
  templateUrl: './message-report.component.html',
  styleUrls: ['./message-report.component.scss']
})
export class MessageReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
